var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.updateExists)?_c('div',{staticClass:"update-banner"},[_vm._v(" Uma nova versão está disponível. "),_c('button',{on:{"click":_vm.refreshApp}},[_vm._v("Atualizar")])]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }